import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import App from './App.tsx';
import { register as registerServiceWorker } from './services/serviceWorkerRegistration';
import './index.css';

// Register the offline app-shell service worker BEFORE app render so registration
// cannot be interrupted by a render-time failure (register() itself is guarded:
// no-op where serviceWorker is unsupported, registers after window load).
registerServiceWorker();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HashRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </HashRouter>
  </React.StrictMode>
);
